import { create } from 'zustand';

type Dentista = {
  id: number;
  nome: string;
  especialidades: string;
};

type Clinica = {
  clinicaId: number;
  nomeFantasia: string;
  endereco: string;
  bairro: string;
  municipio: string;
  uf: string;
  cep: string;
  telefone: string;
  latitude: string;
  longitude: string;
  dentistas: Dentista[];
};

type Store = {
  clinicas: Clinica[];
  total: number;
  paginaAtual: number;
  setClinicas: (clinicas: Clinica[]) => void;
  setTotal: (total: number) => void;
  setPaginaAtual: (pagina: number) => void;
  fetchData: (params: {
    stateId: number;
    cityId: number;
    specialtyId: number;
  }) => Promise<void>;
};

export const useDentistStore = create<Store>((set, get) => ({
  clinicas: [],
  total: 0,
  paginaAtual: 1,
  setClinicas: clinicas => set({ clinicas }),
  setTotal: total => set({ total }),
  setPaginaAtual: paginaAtual => set({ paginaAtual }),

  fetchData: async ({ stateId, cityId, specialtyId }) => {
    const { paginaAtual } = get();
    console.log('[DEBUG] Chamando fetchData com página:', paginaAtual);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_OG_API_URL}/info/RedeVendas?` +
          `ufId=${stateId}&municipioId=${cityId}&especialidadeId=${specialtyId}` +
          `&quantidade=5&page=${paginaAtual}`,
      );
      if (!res.ok) throw new Error('Erro na requisição');
      const data = await res.json();
      console.log('[DEBUG] Dados recebidos da API:', data);
      set({ clinicas: data.items, total: data.total });
    } catch (err) {
      console.error('Erro ao buscar dados:', err);
    }
  },
}));

type DentistStoreState = {
  data: any;
  setDocList: (data: any) => void;
};

export const useDentistStoreState = create<DentistStoreState>((set, get) => ({
  data: {},
  setDocList: data => set(() => ({ data: data })),
  action: () => {
    const data = get().data;
  },
}));
